module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAADpJREFUOBFjYCAA3nuY/AdhAsoYmAgpIFZ+1CDCITX4woiRmDRC2GMM1EtHBC0bTdnUC+zBlyCp5iIAnqoMMuV9eOsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/plus-icon.png
// module id = 224
// module chunks = 0